import { render, staticRenderFns } from "./GRCRiskForm.vue?vue&type=template&id=3c8e311e&scoped=true&"
import script from "./GRCRiskForm.vue?vue&type=script&lang=js&"
export * from "./GRCRiskForm.vue?vue&type=script&lang=js&"
import style0 from "./GRCRiskForm.vue?vue&type=style&index=0&id=3c8e311e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e311e",
  null
  
)

export default component.exports